import {Component, OnInit, AfterViewInit, ViewEncapsulation} from '@angular/core';
import { PluginsService } from '../../sofbox/plugins.service';
import { subHeader } from '../../../constants/menu';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { RestProvider } from '../../shared/services/rest.provider';
import { EnvService } from '../../shared/services/env.service';

@Component({
  selector: 'app-index',
  templateUrl: './index.component.html',
  styleUrls: ['./index.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class IndexComponent implements OnInit, AfterViewInit {
  public href: string = "";
  public bannerHeaderText: string;
  public bannerSubHeaderText: string;
  public records : any[] = [];
  public navLogo: string;
  public socialNavItems: any [] = [];

  clientId: string;
  loginUrl: string;
  accountId: string;
  currentDate: any;

  public navItems: any = [
    { href: '#iq-home', title: 'Home',
      _is_active : true,
      children: true,
      child: subHeader
    },
  ];

  constructor(private plugins: PluginsService,
              public restProvider: RestProvider,
              private env: EnvService,
              public router: Router,
              public route: ActivatedRoute) {
                  const parsedUrl = new URL(window.location.href);
                  const baseUrl = parsedUrl.origin;
                  this.setAPIUrl(baseUrl);
                  window.location.href = this.loginUrl;
  }

  setAPIUrl(baseUrl){
      switch(baseUrl) {
        case 'https://talk.dev.memd.me':
          this.env.CORE_API_URL = 'https://dev-integrations.memd.me';
          localStorage.setItem('partnerUrl','https://dev-partners.memd.me');
          this.loginUrl = 'https://patient.dev.memd.me';
          break;
        case 'https://talk.staging.memd.me':
          this.env.CORE_API_URL = 'https://staging-integrations.memd.me';
          localStorage.setItem('partnerUrl','https://staging-partners.memd.me');
          this.loginUrl = 'https://patient.staging.memd.me';
          break;
        case 'https://talk.memd.me':
          this.env.CORE_API_URL = 'https://integrations.memd.me';
          localStorage.setItem('partnerUrl','https://partners.memd.me');
          this.loginUrl = 'https://patient.memd.me';
          break;
        default:
          this.env.CORE_API_URL = 'https://dev-integrations.memd.me';
          localStorage.setItem('partnerUrl','https://dev-partners.memd.me');
          this.loginUrl = 'https://patient.dev.memd.me';
      }
  }

  ngOnInit() {}

  ngAfterViewInit() {
  }

}
